import {IconName, IconPrefix} from '@fortawesome/fontawesome-svg-core';

function useEvolutionDashboard() {
  function getDifferenceColor(gradeDifference: number): string {
    if (gradeDifference > 0) return '#2fac66';
    if (gradeDifference < 0) return '#962f36';
    return 'gray';
  }

  function getDifferenceText(
    gradeDifference: number | null | undefined,
  ): string | undefined {
    if (gradeDifference == null) return undefined;

    const gradeDifferenceSign = gradeDifference > 0 ? '+' : '';
    return `${gradeDifferenceSign}${gradeDifference} pontos`;
  }

  function getTrendPropriety(grade_difference: number) {
    if (grade_difference > 0) {
      return {
        icon: ['fas', 'arrow-up'] as [IconPrefix, IconName],
        color: '#2fac66',
      };
    }

    if (grade_difference < 0) {
      return {
        icon: ['fas', 'arrow-down'] as [IconPrefix, IconName],
        color: '#962f36',
      };
    }

    return {
      icon: ['fas', 'equals'] as [IconPrefix, IconName],
      color: '#f3af31',
    };
  }

  return {
    getDifferenceColor,
    getDifferenceText,
    getTrendPropriety,
  };
}

export default useEvolutionDashboard;
